import batchVisible from '../../../../actions/batchVisible'
import {buildDetailsQueue} from '../../../../actions/buildDetailsQueue'
import {receiveBuildChanges} from '../../../../actions/builds'
import type {AppThunk} from '../../../../actions/types'
import {getBuildChangesArg} from '../../../../rest/arguments'
import {restApi} from '../../../../services/rest'
import type {BuildId} from '../../../../types'
import {toBuildId} from '../../../../types'
import {internalProps} from '../../../../types/BS_types'
import {Namespace} from '../../../../utils/namespace'
import {unsubscribeOnSuccess} from '../../../../utils/refetchable'

const CHANGES_LIMIT = Number(internalProps['teamcity.internal.buildChangesPopupLimit'])

export const fetchChangesQueue: (id: BuildId) => AppThunk<void> = batchVisible({
  queue: buildDetailsQueue,
  namespace: Namespace.CHANGES,
  request: (id, dispatch) =>
    unsubscribeOnSuccess(
      dispatch(
        restApi.endpoints.getBuild.initiate(
          getBuildChangesArg({buildId: toBuildId(id), count: CHANGES_LIMIT}),
          {forceRefetch: true},
        ),
      ),
    ).then(({data}) => (data != null ? [data] : [])),
  action: receiveBuildChanges,
})
